import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import RowShip from "./RowShip";
import { Box, List, TextField } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  heading: {
    color: "#ff4717",
  },
  mb: {
    marginTop: "15px",
  },
  root: {
    display: "flex",
    padding: "0px",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },


  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: "65px",
    height: "100vh",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "white",
  },
  theadingstyles: {
    background: "rgb(26 26 49)",
    padding: "12px",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    color: "white",
    fontSize: "16px",
  },

  activeListColor: {
    color: "#ff4717 !important",
  },
  shiplist: {
    "&.Mui-selected .MuiListItemText-root span": {
      color: "#ff4717 !important",
    },
  },
  // shiplistheading:{
  //   "&.makeStyles-theadingstyles-2275":{
  //     width: "520px",
      
  //   },
  //   marginLeft:"50px",
  //   marginTop:"10px"
  // },
  
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function TrendsList(props) {
  const classes = useStyles();
  const { shipList,transformerListequip, setTransformerSelectedId, selectedEquimentKey, setSelectedEquimentKey,} = props;
  const [open, setOpen] = React.useState(false);
 
  useEffect(() => { }, []);
  
  const transformerSelectedId = (equimentKey, equimentKeyList, VesselKey, Field) => {
   // setSelectedVesselKey(VesselKey)
    setSelectedEquimentKey(equimentKey);
   // setSelectedVesselList([...equimentKeyList])
    setTransformerSelectedId(equimentKey, equimentKeyList, VesselKey,Field);
  }
 
  return (
    <div>
      <Grid container fluid="md" spacing={3} >
      <Grid item xs={12}>
          <Typography
            variant="h5"
            align="left"
            className={clsx(classes.heading, classes.theadingstyles) + " bai-font"}
          >
            Ship List
          </Typography>
          <Paper
            className={classes.paper + " scrollBar"}
            style={{ height: "420px", overflow: "auto",marginTop: "5px"}}
          >

            <listStyled component="nav" className="scroll-list">
              {shipList.length ? shipList.map((row) => {

                return (
                  <React.Fragment>
                    <RowShip transformerListequip={transformerListequip} rows={row}  setTransformerSelectedId={transformerSelectedId} 
                     selectedEquimentKey={selectedEquimentKey} setSelectedEquimentKey={setSelectedEquimentKey}/>
                  </React.Fragment>
                )
              })
                : <p align="center" style={{color: "rgba(0, 0, 0, 0.54)"}}>No data found</p>}
            </listStyled>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
